import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TemplateLibraryIcon from "../../assets/icons/template_rec.svg2";
import FiltersIcon from "../../assets/icons/filter.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import BroadcastIcon from "../../assets/icons/prod_broadcast.svg2";
import MyBadge from "../Common/MyBadge";
import MySearch from "../Common/MySearch";
import { proxyAPI } from "../proxyAPI";
import MyPagination from "../Common/MyPagination";
import WhiteButton from "../Common/WhiteButton";
import MyTemplateCard from "./MyTemplateCard";
import TemplateDetail from "./TemplateDetail";
import EngineerVisitIcon from "../../assets/icons/engineer.svg2";
import TickIcon from "../../assets/icons/tick.svg2";
import ApiDataCollectionIcon from "../../assets/icons/api_connections.svg2";
import Subheading from "../Common/Subheading";
import NewFeature from "../Builder/Components/NewFeature";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function APIDataCollectionLibrary({ isModal }) {
  const confirmDialog = useConfirmDialog();
  const navigate = useNavigate();
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [totalResults, setTotalResults] = useState(0);
  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [status, setStatus] = useState("");
  const [orderBy, setOrderBy] = useState("used-last");
  const [search, setSearch] = useState("");

  const loader = async (page = 0, perPage = 10) => {
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `json-api-data-collections`,
      // ?search=${search}&orderBy=${orderBy}&status=${status}&offset=${
      //   page * perPage
      // }&limit=${perPage}`,
    });
    if (data) {
      setAvailableTemplates(data.collections || []);
      setTotalResults(data.total);
      setSelectedTemplate(data.collections?.[0] ?? null);
    }
  };

  const deleteAPICollection = async (uuid) => {
    const res = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `json-api-data-collection/${uuid}`,
      method: "DELETE",
    });
    if (res) {
      loader();
    }
  };

  useEffect(() => {
    const timeOut = setTimeout(() => {
      loader();
    }, 500);

    return () => {
      clearTimeout(timeOut);
    };
  }, [search, orderBy, status]);

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={ApiDataCollectionIcon}
            heading="Data structures"
            subheading="See all of your data structures."
          />
        </div>

        <div className="d-flex gap-2 align-items-center">
          <WhiteButton
            as="RRLink"
            icon={TemplateLibraryIcon}
            to="/library/api-data-collections/add"
            heading="Add"
            subheading="Data structure"
          />
        </div>
        {/* <div className="d-flex gap-2 align-items-center">
          <FiltersIcon width={20} />
          <span className="fw-bold p-2">Filter options:</span>
          <div className="flex-grow-1">
            <Input
              isMulti
              onChange={() => null}
              value={["FILTER 1", "FILTER 2"]}
            />
          </div>
          <div>
            <span className="fw-bold p-2">Order by:</span>
          </div>
          <div>
            <Form.Select
              aria-label="newTemplate-select"
              onChange={(e) => {
                setOrderBy(e.target.value);
              }}
              value={orderBy}
            >
              <option value="created-last">Created Last</option>
              <option value="created-first">Created First</option>
              <option value="updated-first">Updated First</option>
              <option value="updated-last">Updated Last</option>
              <option value="used-last">Used Last</option>
              <option value="used-first">Used First</option>
            </Form.Select>
          </div>
          <div>
            <Input
              value={[status]}
              onChange={(v) => {
                setStatus(v[0]);
              }}
              inputType="radio"
              options={[
                { value: "draft", label: "DRAFT" },
                { value: "published", label: "PUBLISHED" },
                { value: "archived", label: "ARCHIVED" },
                { value: "", label: "ALL" },
              ]}
            />
          </div>
        </div> */}
      </div>{" "}
      <div className="mb-3 bg-colored-reverse p-3 rounded-3 d-flex justify-content-between gap-3 align-items-end">
        {/* <FiltersIcon width={20} className="bg-white m-2 rounded" /> */}
        {/* <span className="fw-bold p-2">Filter options:</span>
                      <div className="flex-grow-1">
                        <Input
                          isMulti
                          onChange={() => null}
                          value={["FILTER 1", "FILTER 2"]}
                        />

                      </div> */}
        <div className="d-flex gap-2 align-items-center">
          <div>
            <span className="fw-bold p-2 text-white">Order by:</span>
          </div>
          <div>
            <Form.Select
              aria-label="newTemplate-select"
              onChange={(e) => {
                setOrderBy(e.target.value);
              }}
              value={orderBy}
            >
              <option value="created-last">Created Last</option>
              <option value="created-first">Created First</option>
              <option value="updated-first">Updated First</option>
              <option value="updated-last">Updated Last</option>
              <option value="used-last">Used Last</option>
              <option value="used-first">Used First</option>
            </Form.Select>
          </div>
          <div>
            <Input
              value={[status]}
              onChange={(v) => {
                setStatus(v[0]);
              }}
              inputType="radio"
              options={[
                { value: "draft", label: "DRAFT" },
                { value: "published", label: "PUBLISHED" },
                { value: "archived", label: "ARCHIVED" },

                { value: "all", label: "ALL" },
              ]}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end ">
          <MySearch
            placeholder="Search for a template"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>
      {/* / */}
      <Row className="mb-5 my-3 ">
        <Col xs={12} lg={4} className="pe-5 border-end border-2">
          <div
            style={{
              maxHeight: 500,
              overflowY: "auto",
              scrollbarColor: "purple",
            }}
            className="pe-2 fw-bold"
          >
            <span className="fs-3"> Template Results</span>
            <MyBadge count={totalResults} />
            {availableTemplates.map((template) => (
              <div
                key={template.Uuid}
                onDoubleClick={() => {
                  navigate(`/library/api-data-collections/${template.Uuid}`);
                }}
              >
                <MyTemplateCard
                  isSelected={selectedTemplate === template}
                  onSelect={() => setSelectedTemplate(template)}
                >
                  <div>{template.Label}</div>
                </MyTemplateCard>
              </div>
            ))}
          </div>
          <MyPagination total={totalResults} onPaginate={loader} />
        </Col>
        <div className="col-lg-1"></div>
        <Col className="fw-bold">
          {selectedTemplate && (
            <>
              About this template:
              <div className="my-3">
                <div
                  className={`btn w-75 h-100 px-0  text-start rounded-3 position-relative `}
                >
                  <div className="d-flex align-items-center">
                    <div className="bg-purple-gradient rounded-circle me-3">
                      <EngineerVisitIcon width={60} />
                    </div>
                    <div className="me-3">
                      <h3 className="text-black fw-bold">
                        {selectedTemplate.Label}
                        {/* {selectedTemplate.isLogicReady ? (
                <span className=" fw-bold bg-info rounded-pill text-white ms-2 px-2 py-1 text-xs">
                  <LogicIcon width={20} className="white " /> LOGIC READY
                </span>
              ) : (
                ""
              )} */}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="fw-bold my-4">
                  This template will setup the following for you:
                </div>
                <Row>
                  <div className="col-6">
                    <TemplateDetail
                      label="Label"
                      value={selectedTemplate.Label || "No label defined"}
                    />
                  </div>
                  <div className="col-6">
                    <TemplateDetail
                      label="Path"
                      value={selectedTemplate.Path}
                    />
                  </div>

                  <div className="col-6">
                    <TemplateDetail
                      label="Fields"
                      value={
                        selectedTemplate.Fields?.map(
                          (field) => field.Path
                        ).join(", ") ?? "No fields defined."
                      }
                    />
                  </div>
                </Row>
              </div>
              <div className="d-flex justify-content-start my-5">
                <Link
                  to={`/library/api-data-collections/${selectedTemplate.Uuid}`}
                  className="btn bg-colored-reverse rounded-pill"
                >
                  <div className="d-flex align-items-center ">
                    <TickIcon
                      width={40}
                      className=" white rounded-circle p-1"
                    />
                    <h5 className="my-0 mx-3 text-white">Edit</h5>
                  </div>
                </Link>
                <Button
                  className="btn bg-colored-reverse rounded-pill ms-2 px-3 border-0"
                  onClick={async () => {
                    const ans = await confirmDialog(
                      "Are you sure?",
                      `Are you sure you want to delete this template? <br> ${selectedTemplate.Label}`
                    );
                    if (ans) {
                      deleteAPICollection(selectedTemplate.Uuid);
                    }
                  }}
                >
                  <div className="d-flex align-items-center ">
                    <h5 className="my-0 mx-3 text-white">Delete</h5>
                  </div>
                </Button>
              </div>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
